
import bgimg from "../../../../assets/images/mainbg.png"
import styled from "@emotion/styled";
const VideoBkMAin = styled.div`
background-size:cover;
background-repeat:no-repeat;
background-position:center center;
background-image: url(${bgimg});
border-radius:30px;
min-height:80vh;
position:relative;
padding: 0;
    display: flex;
    margin: 0;
    flex-flow: column;
    align-items: center;
    @media screen and (max-width:500px){
    min-height: 75vh;
    }
    @media screen and (max-width:400px){
    min-height: 70vh;
    }
`;
const Dogimg = styled.img`
  width: 100%;
  height: auto;
  max-width:63vh;
  position:absolute;
  bottom:0;
`;
export{VideoBkMAin,Dogimg}